import React, { useRef } from 'react';
import WidgetReference from './WidgetReference';
import './EntryWidgets.css';

export default function EntryWidgets() {
  const walkthroughRef = useRef(null);

  const scrollToWalkthrough = () => {
    const walkthrough = walkthroughRef.current;
    if (!walkthrough) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    walkthrough.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    walkthrough.focus({ preventScroll: true });
  };

  return (
    <div className="entry-widgets">
      <button
        type="button"
        className="entry-widgets__guide-button"
        onClick={scrollToWalkthrough}
        aria-controls="widget-theme-setup"
      >
        How to add widgets to your theme
      </button>
      <WidgetReference guideId="entry-widgets" />
      <section
        id="widget-theme-setup"
        className="entry-widgets__walkthrough"
        aria-label="How to add widgets to your theme"
        ref={walkthroughRef}
        tabIndex={-1}
      >
    <iframe
      src="https://scribehow.com/embed/Setup_Product_Entry_Widgets_with_Clean_Sweeps__WaGsKUjtRByLNmAZTH8B_g?skipIntro=true&removeLogo=true&as=scrollable"
      height="640"
      title="Entry Widgets"
      allowFullScreen
    />
      </section>
    </div>
  );
}
